import moment from "moment";
import AxiosService from "./axiosServices";
const axiosService = new AxiosService();

export default class InvestigationService {
  getProjectName = () => {
    return axiosService.Get(`api/cam/visualization/list-projects/`);
  };
  getParameterList = (projectId) => {
    let params = {
      project_id: projectId,
    };
    return axiosService.Get(`api/cam/get-parameters-list/`, {
      params: params,
    });
  };
  getProjectWithParametersName = () => {
    return axiosService.Get(`api/cam/list-validated-parameters/`);
  };

  getInvestigationTableData = (data) => {
    const transformedData = [];
    if (data && data?.filtersData && Array.isArray(data?.filtersData)) {
      data?.filtersData?.forEach((entry) => {
        const parameterName = entry.parameterName || "";
        const minValue = entry.minValue || "";
        const maxValue = entry.maxValue || "";
        const rangeType = entry.rangeType;

        const transformedEntry = {
          parameter_name: parameterName,
          ...(rangeType === "Exact"
            ? { parameter_value: minValue, parameter_value_min: "" }
            : { parameter_value: "", parameter_value_min: minValue }),
          parameter_value_max: maxValue,
        };

        transformedData.push(transformedEntry);
      });
    }

    const body = {
      filters: transformedData,
    };
    return axiosService.Post(
      `api/cam/get-data-for-investigation/?page=${data?.page}&page_size=${data?.page_size}`,
      body,
    );
  };

  getReportsData = (data) => {
    let params = {
      date_min: "2023-01-10T17:10:08.598+00:00",
      date_max: "2023-11-21T17:10:08.598+00:00",
    };
    return axiosService.Get(`api/cam/get-data-reports/`, {
      params: params,
    });
  };
  getFilterationReporstList = (data) => {
    return axiosService.Get(`api/cam/get-filtration-report-list/`, {});
  };
  previewBatchRecords = (data) => {
    const body = {
      body: {
        report_s3_key: data,
      },
    };

    return axiosService.Post(`api/cam/preview-filtration-report/`, body);
  };
  exportInvestigationData = (fileName, filltersData, data) => {
    const body = {
      body: {
        filters: filltersData,
        data: data,
        report_name: fileName,
      },
    };
    return axiosService.Post(`api/cam/generate-filtration-report/`, body);
  };

  getVisualizationDetails = (id) => {
    return axiosService.Get(`api/cam/visualization/get-detail/?id=${id}`, {});
  };
  getVisualizationProjects = () => {
    return axiosService.Get(`api/cam/visualization/table-details/`, {});
  };

  submitForVisualizationResult = (data) => {
    const obj = {
      body: {
        id: data.id,
        label: data.label,
        table_name: data.table_name,
      },
    };
    return axiosService.Post(`api/cam/visualization/save-result/`, obj);
  };
  submitForVisualizationQuery = (data) => {
    const obj = {
      body: {
        table_name: data.table_name,
        user_input: data.user_input,
      },
    };
    return axiosService.Post(
      `api/cam/visualization/submit-visualization-requirement/`,
      obj,
    );
  };
  getHistoryDataForVisualization = () => {
    return axiosService.Get(`api/cam/visualization/history/`, {});
  };

  getFilesForPreviewList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      file_type: data?.fileType,
      status: data?.status,
      created_after: data?.formattedStartDate,
      created_before: data?.formattedEndDate,
      ...(data?.type !== null && {
        [data?.type === "project" ? "project_name" : "batch_name"]: data?.value,
      }),
    };
    return axiosService.Get(`api/cam/list-output-files/`, {
      params: params,
    });
  };

  getTasksList = (data) => {
    const params = {
      page_size: data?.page_size,
      page: data?.page,
      project_id: data?.project_id,
    };
    return axiosService.Get(`api/cam/task-status/`, {
      params: params,
    });
  };

  getDrugTypeListBatchAndUserNames = () => {
    return axiosService.Get(`api/cam/batch-tiles-filters-data/`);
  };

  getDashboardLogsTilesDta = (data) => {
    const keyChangeData = {
      drug_type: data?.selectedProduct,
      project_name: data?.selectedTemplate,
      batch_name: data?.selectedBatch,
      created_batch_after:
        data?.dateRange[0] !== "" && data?.dateRange[0] !== null
          ? moment(data?.dateRange[0]).format("YYYY-MM-DD")
          : "",
      created_batch_before:
        data?.dateRange[1] !== "" && data?.dateRange[1] !== null
          ? moment(data?.dateRange[1]).format("YYYY-MM-DD")
          : "",
    };
    return axiosService.Get(`api/cam/batch-tiles-list/`, {
      params: keyChangeData,
    });
  };

  getBatchNames = (id) => {
    return axiosService.Get(`api/cam/batch-tiles-filters-data/${id}`);
  };

  getBatchesTilesOfProject = (data) => {
    const keyChangeData = {
      batch_name: data?.batchName,
      project_id: data?.projectId,
      start_date:
        data?.dateRange[0] !== ""
          ? moment(data?.dateRange[0]).format("YYYY-MM-DD")
          : "",
      end_date:
        data?.dateRange[0] !== ""
          ? moment(data?.dateRange[1]).format("YYYY-MM-DD")
          : "",
    };

    return axiosService.Get(`api/cam/batch-tiles-list/${data?.projectId}/`, {
      params: keyChangeData,
    });
  };

  getBatchDocuments = (batchId) => {
    return axiosService.Get(`api/cam/get-batch-documents/`, {
      params: { batch_id: batchId },
    });
  };

  getBatchLogFiltersData = (data) => {
    // return axiosService.Get(`api/cam/get-batch-logs-filters/${data}/`, {
    return axiosService.Get(`api/cam/get-batch-logs-filters/${data}/`, {
      // params: { data },
    });
  };

  getBatchParameters = (batchId) => {
    return axiosService.Get(`api/cam/get-batch-parameters/`, {
      params: { batch_id: batchId },
    });
  };

  getBatchOrProjectLogs = (id, type, batchDetailsFilters) => {
    if (type === "batch") {
      const renamedKeys = {
        user_group: batchDetailsFilters?.role,
        document_name: batchDetailsFilters?.document,
        activity_name: batchDetailsFilters?.activity,
        parameter_name: batchDetailsFilters?.parameter,
      };
      return axiosService.Get(`api/cam/get-batch-logs/${id}/`, {
        params: renamedKeys,
      });
    } else {
      return axiosService.Get(`api/cam/get-template-logs/${id}/`);
    }
  };

  getTotalProjectsAndBatchesWithStatusCount = () => {
    return axiosService.Get(`api/cam/dashboard-widget-one-counts/`);
  };

  getDrugProducts = () => {
    return axiosService.Get(`api/cam/get-drug-types/`);
  };

  getCountsPerDrugProducts = (productName) => {
    if (productName) {
      return axiosService.Get(`api/cam/dashboard-drug-product-widget/`, {
        params: { drug_type: productName },
      });
    } else {
      return axiosService.Get(`api/cam/dashboard-drug-product-widget/`);
    }
  };

  getProjectsAndBatches = () => {
    return axiosService.Get(`api/cam/batch-status-widget-filter/`);
  };

  getBatchStatus = (project, batch) => {
    return axiosService.Get(`api/cam/dashboard-batch-widget/${batch}/`);
  };

  getAllBatchTilesFilters = () => {
    return axiosService.Get(`api/cam/dashboard-all-batches-filters/`);
  };

  getAllBatchTiles = (selectedFilterData) => {
    const params = {
      project_name: selectedFilterData?.selectedTemplate,
      drug_type: selectedFilterData?.selectedProduct,
      batch_name: selectedFilterData?.selectedBatch,
      created_batch_after:
        selectedFilterData?.dateRange[0] !== "" &&
        selectedFilterData?.dateRange[0] !== null
          ? moment(selectedFilterData?.dateRange[0]).format("YYYY-MM-DD")
          : "",
      created_batch_before:
        selectedFilterData?.dateRange[1] !== "" &&
        selectedFilterData?.dateRange[1] !== null
          ? moment(selectedFilterData?.dateRange[1]).format("YYYY-MM-DD")
          : "",
    };

    return axiosService.Get(`api/cam/dashboard-all-batches-widget/`, {
      params: params,
    });
  };

  getPdfLink = (data) => {
    return axiosService.Post(`api/cam/generate-log-report-pdf/`, {
      data: data,
    });
  };

  getManageOutputUrl = (data) => {
    return axiosService.Get(`api/cam/preview-output-file/${data}/`);
  };
}
